export class PaginationOptions {
  perPage: number | string = 10;
  pageNumber: number = 1;
  sort: string = 'date_updated';
  direction: string = 'asc';
  filter: string = 'not_trashed';
  search?: string = '';
  searchField?: string = '';

  private section!: string;

  public toggleDirection() {
    this.direction = this.direction === 'desc' ? 'asc' : 'desc';
  }

  public toggleFilter() {
    this.filter = this.filter === 'trashed' ? 'not_trashed' : 'trashed';
  }

  public setSearchField(feild: string) {
    console.log('Set value to ' + feild);

    this.searchField = feild;
  }

  public resetDirection() {
    this.direction = 'asc';
  }

  public directionIsAsc(): boolean {
    return this.direction === 'asc';
  }

  constructor(options: PaginationOptionsInterface, section: string, useSaved: boolean = true) {
    this.section = section;
    let savedOptionsForSection = localStorage.getItem(section);
    if (savedOptionsForSection && useSaved && window.location.hostname != 'localhost') {
      this.perPage = JSON.parse(savedOptionsForSection).perPage;
      this.pageNumber = this.pageNumber;
      this.sort = JSON.parse(savedOptionsForSection).sort;
      this.searchField = JSON.parse(savedOptionsForSection).searchField;
      this.direction = JSON.parse(savedOptionsForSection).direction;
      this.search = this.search;
      this.filter = this.filter;
      return;
    }

    if (options.perPage) {
      if (options.perPage === 'ALL') {
        this.perPage = 0;
      } else {
        this.perPage = options.perPage;
      }
    }
    if (options.pageNumber) {
      this.pageNumber = options.pageNumber;
    }
    if (options.sort) {
      this.sort = options.sort;
    }
    if (options.direction) {
      this.direction = options.direction;
    }

    if (options.filter) {
      this.filter = options.filter;
    }

    this.saveUpdatedOptions();
  }

  public saveUpdatedOptions() {
    localStorage.setItem(
      this.section,
      JSON.stringify({
        perPage: this.perPage,
        pageNumber: this.pageNumber,
        sort: this.sort,
        direction: this.direction,
        filter: this.filter,
      })
    );
  }

  public static getPaginationQueryParameters(
    paginationOptions: PaginationOptions
  ): string {
    return `page=${paginationOptions.pageNumber}&perPage=${paginationOptions.perPage}&sort=${paginationOptions.sort}&direction=${paginationOptions.direction}&filter=${paginationOptions.filter}&search=${paginationOptions.search}&search_field=${paginationOptions.searchField}`;
  }
}

interface PaginationOptionsInterface {
  perPage?: number | string;
  pageNumber?: number;
  sort?: string;
  direction?: string;
  filter?: string;
  search?: string;
}
